export enum CodeInjectionType {
  HEADER = 'header',
  FOOTER = 'footer',
  BODY = 'body',
}
